import Testimony from './Testimony'
import style from './Testimony.module.css'

export default function(props) {
	
	const testimonies = []
	for (let i=0; i<props.num; i++) {
		testimonies.push(<Testimony key={`testimony_${i}`} data={props.data} />)
	}



	return (
		<div className={style.testimonies}>{testimonies}</div>
	)
	
}